import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useParams, useHistory } from 'react-router-dom';
import { Button, Card, CardBody, Col, Row, Input } from 'reactstrap';
import PreloaderWidget from '../../../components/Loader';
import PageTitle from '../../../components/PageTitle';
import { incubatee_details, delete_scheme, list_Banner } from '../../../helpers/actions/api.functions';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import * as FeatherIcon from 'react-feather';
import parse from 'html-react-parser';
import FilterButton from '../../../components/FilterButton';
import { list_schemes, edit_scheme } from '../../../helpers/actions/api.functions';
const BannerDetails = () => {
    const history = useHistory();
    let userdata = localStorage.getItem('active_user') ? JSON.parse(localStorage.getItem('active_user')) : null;
    const param = useParams();
    const [data, setData] = useState({});
    const [isActive, setIsActive] = useState(true);
    const [modalb, setModalb] = useState(false);

    const handleClose = () => {
        setModalb(false);
    };
    const getIncubatees = () => {
        setIsActive(true);
        list_Banner()
            .then((res) => {
                setIsActive(false);
                setData(res.filter((sc) => sc.id == param.id)[0]);
            })
            .catch((err) => {
                setIsActive(false);
                toast.error(err.response.data.message);
            });
    };

    const sizePerPageRenderer = ({ options, currSizePerPage, onSizePerPageChange }) => (
        <React.Fragment>
            <label className="d-inline mr-1">Show</label>
            <Input
                type="select"
                name="select"
                id="no-entries"
                className="custom-select custom-select-sm d-inline col-1"
                defaultValue={currSizePerPage}
                onChange={(e) => onSizePerPageChange(e.target.value)}>
                {options.map((option, idx) => {
                    return <option key={idx}>{option.text}</option>;
                })}
            </Input>
            <label className="d-inline ml-1">entries</label>
        </React.Fragment>
    );
    const defaultSorted = [
        {
            dataField: 'id',
            order: 'desc',
        },
    ];
    const columns = [
        {
            dataField: 'entity_name',
            text: 'Name',
            sort: true,
            formatter: (rowContent) => {
                return <div className="text-capitalize">Yuva Bootcamp</div>;
            },
        },

        {
            dataField: 'industry',
            text: 'Email',
            sort: true,
            formatter: (rowContent) => {
                return <div className="text-capitalize">IAC</div>;
            },
        },
    ];

    useEffect(() => {
        getIncubatees();
    }, []);
    if (isActive) {
        return <PreloaderWidget />;
    }

    const listData = (id) => {
        list_Banner(id)
            .then((res) => {
                setData(res.result);
                setIsActive(false);
            })
            .catch((err) => {
                setIsActive(false);
                toast.error(err.response.data.message);
            });
    };
    if (isActive) {
        return <PreloaderWidget />;
    }
    const openFile = (file) => {
        if (file) {
            window.open(file, '_blank');
        }
    };
    return (
        <React.Fragment>
            <Row className="page-title">
                <Col md={12}>
                    <PageTitle
                        breadCrumbItems={[
                            { label: 'Banner List', path: '/banner-list' },
                            { label: 'Details', path: '/banner-detail', active: true },
                        ]}
                        title="Banner Details"
                    />
                </Col>
            </Row>
            <Row>
                <Col md={12} xl={12} className="mx-auto">
                    <Card>
                        <CardBody className="pb-0">
                            <div className="mt-3 pt-2 ">
                                {/* <h4 className="mb-3 font-size-15">Detailed  Information</h4> */}
                                <div className="table-responsive incu-detail">
                                    <table className="table  table-striped  text-muted">
                                        <tbody className="">
                                            <tr>
                                                <th scope="row">Banner Name</th>
                                                <td className="text-capitalize">{data?.name}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Status </th>
                                                <td>
                                                    <span
                                                        className={`badge ${
                                                            data?.status?.toLowerCase() === 'active'
                                                                ? 'badge-soft-success'
                                                                : 'badge-soft-danger'
                                                        }`}>
                                                        {data?.status}
                                                    </span>
                                                </td>
                                            </tr>

                                            <tr>
                                                <th scope="row">Banner Image </th>
                                                <td className="pt-2">
                                                    <Button
                                                        size="sm"
                                                        color={'warning'}
                                                        onClick={(e) => {
                                                            openFile(data?.file);
                                                        }}>
                                                        Download
                                                    </Button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <br />

                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

        </React.Fragment>
    );
};

export default BannerDetails;
